var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-bar" }, [
    _c("div", { staticClass: "header-bar__info" }, [
      _c("div", { staticClass: "header-bar__main" }, [
        _vm._v("Заказ обратного звонка\n      "),
        _c("span", { staticClass: "header-bar__version" }, [
          _vm._v("v. " + _vm._s(_vm.getPluginVersion()))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dev-block" }, [
        _c("div", { staticClass: "dev-block__item" }, [
          _c("span", { staticClass: "dev-block__label" }, [
            _vm._v("Разработчик:")
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://bodysite.ru", target: "_blank" }
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.getPluginUrl() + "img/bodysite-logo.svg",
                  alt: "Bodysite",
                  title: "Bodysite",
                  width: "150"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dev-block__item" }, [
          _c("span", { staticClass: "dev-block__label" }, [
            _vm._v("Подписывайтесь:")
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "https://t.me/bodysite", target: "_blank" }
            },
            [
              _c("img", {
                staticClass: "dev-block__icon",
                attrs: { src: _vm.getPluginUrl() + "img/telegram.svg" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href:
                  "https://www.youtube.com/channel/UCbPi3dch9M-lInwPiO4aMEQ",
                target: "_blank"
              }
            },
            [
              _c("img", {
                staticClass: "dev-block__icon",
                attrs: { src: _vm.getPluginUrl() + "img/youtube.svg" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: {
                href: "https://vk.com/bodysiteofficial",
                target: "_blank"
              }
            },
            [
              _c("img", {
                staticClass: "dev-block__icon dev-block__icon_last",
                attrs: { src: _vm.getPluginUrl() + "img/vk.svg" }
              })
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "link-bar" }, [
      _c("ul", { staticClass: "link-bar__list" }, [
        _c("li", { staticClass: "link-bar__item" }, [
          _c(
            "a",
            {
              staticClass: "link-bar__link",
              attrs: {
                href: "https://bodysite.ru/help/ordercall/manual/",
                target: "_blank"
              }
            },
            [
              _c("img", {
                staticClass: "dev-block__icon",
                attrs: {
                  alt: _vm.getPluginUrl() + "img/help.svg",
                  src: _vm.getPluginUrl() + "img/help.svg"
                }
              }),
              _vm._v("\n          Инструкции по настройке\n        ")
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "link-bar__item" }, [
          _c(
            "a",
            {
              staticClass: "link-bar__link",
              attrs: {
                href: "https://bodysite.ru/help/ordercall/reports/",
                target: "_blank"
              }
            },
            [
              _c("img", {
                staticClass: "dev-block__icon",
                attrs: { src: _vm.getPluginUrl() + "img/support.svg" }
              }),
              _vm._v("\n          Сообщить об ошибке\n      ")
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "link-bar__item" }, [
          _c(
            "a",
            {
              staticClass: "link-bar__link",
              attrs: {
                href: "https://bodysite.ru/help/ordercall/suggestions/",
                target: "_blank"
              }
            },
            [
              _c("img", {
                staticClass: "dev-block__icon",
                attrs: { src: _vm.getPluginUrl() + "img/bulb1.svg" }
              }),
              _vm._v("\n          Предложить улучшение\n        ")
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "link-bar__item" }, [
          _c(
            "a",
            {
              staticClass: "link-bar__link",
              attrs: {
                href:
                  "https://www.webasyst.ru/store/plugin/shop/ordercall/reviews/",
                target: "_blank"
              }
            },
            [
              _c("img", {
                staticClass: "dev-block__icon",
                attrs: { src: _vm.getPluginUrl() + "img/review.svg" }
              }),
              _vm._v("\n          Оставить отзыв\n        ")
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76272aa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76272aa6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/header/MainHeader.vue
// module id = 103
// module chunks = 0